import React, { useCallback, useRef, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { Music } from 'lucide-react';
import useCampaignSpellSync from '../hooks/useCampaignSpellSync';
import { decideCountercharm, syncCountercharm } from '../utils/countercharmService';
import './RollRequests.scss';

/** Countercharm (Bard 7): a creature near the Bard failed a save against Charmed or Frightened, and its player is waiting. */
export default function CountercharmPrompt({ campaignId, characterId, onCombatChange }) {
  const [windows, setWindows] = useState([]), [busy, setBusy] = useState(false), [error, setError] = useState('');
  const lock = useRef(false);
  const load = useCallback(async () => (await syncCountercharm(campaignId, { characterId: String(characterId) })).windows || [], [campaignId, characterId]);
  useCampaignSpellSync({ campaignId: characterId ? campaignId : null, kind: 'fateWindows', load,
    onData: next => setWindows(previous => (JSON.stringify(previous) === JSON.stringify(next) ? previous : next)) });
  const offer = windows[0];
  const decide = async decision => {
    if (!offer || lock.current) return;
    lock.current = true; setBusy(true); setError('');
    try {
      const result = await decideCountercharm(campaignId, offer.windowId, { helperId: String(characterId), decision });
      if (result.combat) onCombatChange?.(result.combat);
      setWindows(previous => previous.filter(item => item.windowId !== offer.windowId));
    } catch (failure) { setError(failure.message); }
    finally { lock.current = false; setBusy(false); }
  };
  if (!offer) return null;
  const self = offer.saverId === String(characterId);
  return <Modal show centered backdrop="static" keyboard={false} className="dnd-modal modern-modal roll-request-prompt" aria-label="Countercharm">
    <Modal.Body>
      <div className="roll-request__row"><span className="roll-request__muted"><Music size={14} aria-hidden="true"/> Countercharm · Reaction</span></div>
      <div className="roll-request__title">{self ? 'You' : offer.saverName} failed a save against {offer.about}</div>
      <div className="roll-request__muted">Use your Reaction to reroll the save with Advantage?</div>
      {error && <Alert variant="danger" className="mt-2 mb-0 py-1 small">{error}</Alert>}
      <Button size="sm" variant="warning" className="w-100 mt-2" disabled={busy} onClick={() => decide('use')}>{busy ? 'Saving…' : 'Use Countercharm'}</Button>
      <Button size="sm" variant="outline-light" className="w-100 mt-1" disabled={busy} onClick={() => decide('skip')}>Not now</Button>
    </Modal.Body>
  </Modal>;
}
